var _ellipse, _ellipse2, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotorFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 6.5,
    rx: 7,
    ry: 3.5,
    fill: "#ED3431"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99996,
    cy: 6,
    rx: 4.84615,
    ry: 2,
    fill: "#8E1F1D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 10,
    height: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99996,
    cy: 6,
    rx: 4.84615,
    ry: 2,
    fill: "#5F1514"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99996,
    cy: 8,
    rx: 4.84615,
    ry: 2,
    fill: "#5F1514"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotorFront);
export default __webpack_public_path__ + "static/media/rotor-front.63c48729e7578410d2b3c2dacf3bf1ec.svg";
export { ForwardRef as ReactComponent };